// extracted by mini-css-extract-plugin
module.exports = {"formPair":"Input_formPair__1r0c0"};